import { render, staticRenderFns } from "./modifySolidityContract.vue?vue&type=template&id=2b59d852&scoped=true&"
import script from "./modifySolidityContract.vue?vue&type=script&lang=js&"
export * from "./modifySolidityContract.vue?vue&type=script&lang=js&"
import style0 from "./modifySolidityContract.vue?vue&type=style&index=0&id=2b59d852&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59d852",
  null
  
)

export default component.exports